module.exports = __webpack_public_path__ + "img/cegp-enigme.7ac8d42e.png";